import Moment from 'moment';

export const getInitialState = function () {
	const defaults = {
		init: true,
		taxonomies: {},
		searchText: '',
		searchQuery: '',
		selectedTaxonomies: {},
		selectedStartDate: null,
		selectedEndDate: null,
		focusedDateInput: null,
		posts: [],
		loading: true,
		postsCount: 0,
		pagesCount: 0,
		currentPage: 1,
		sortBy: 'default',
	};

	const search = location.search.substring(1);
	const searchParams = new URLSearchParams(search);
	const taxParam = document.querySelector('.trip-archive-taxonomy');
	if( taxParam ) {
		const taxParamNumber = taxParam.getAttribute('data-taxonomy');
		const taxParamType = taxParam.getAttribute('data-taxonomy-type');
		// console.log(taxParamNumber, taxParamType);
		defaults['selectedTaxonomies'][taxParamType] = [parseInt(taxParamNumber)];
	}

	if (searchParams.get('sort_by')) {
		defaults['sortBy'] = searchParams.get('sort_by');
	}

	for (const param of searchParams) {
		const key = param[0].replace('amp;', '');
		let val = param[1].split(',');

		if (key.includes('[') && key.includes(']')) {
			// Example: [ 'tax[category]', 'tax', 'category' ];
			const matches = key.match(/^([^\[]+)\[([^\]]+)\]$/i);
			val = val.map((id) => {
				if( isNaN(id) || id === '' || !id ) {
					return false;
				}
				if (id.toString().indexOf('-') > 1) {
					return id;
				}

				return parseInt(id);
			});

			if (matches.length === 3 && val[0] !== false) {
				defaults[matches[1]][matches[2]] = val;
			}

		} else if ('departure_start' === key) {
			const date = Moment(val, 'MM/DD/YYYY');

			if (date.isValid()) {
				defaults.selectedStartDate = date;
			}
		} else if ('departure_end' === key) {
			const date = Moment(val, 'MM/DD/YYYY');

			if (date.isValid()) {
				defaults.selectedEndDate = date;
			}
		} else {
			if (val.length === 1) {
				val = val[0];
			}

			defaults[key] = val;

			if ('searchQuery' === key) {
				defaults.searchText = val;
			}
		}
	}
	// console.log('defaults ', defaults);
	return defaults;

};
